import { helpers } from "../../helpers/helpers.js";

var searchForm = {
	selectors: {
		element: '[data-search]',
		trigger: '[data-search-trigger]',
		target:  '[data-search-target]',
		input:   '[data-search-input]',
		clear:   '[data-search-clear]',
		results: '[data-search-results]'
 	},

	init: function() {
		var self = this;

		$( self.selectors.element ).each( function() {
			var $element = $( this ),
			$trigger = $element.find( self.selectors.trigger ),
			$target = $element.find( self.selectors.target ),
			$input  = $target.find( self.selectors.input ),
			$clear = $target.find( self.selectors.clear ),
			$results = $target.find( self.selectors.results );

			$trigger.on( 'click', function(e) {
				e.preventDefault();
				
				if ( $element.hasClass( 'opened' ) ) {
					$input.trigger( 'blur' );
					$element.removeClass( 'opened' );
					$( document.body ).off( '.search-form' );
				} else {
					$input.trigger( 'focus' );
					$element.addClass( 'opened' );

					$( document.body ).on( 'touchstart.search-form click.search-form', function(e) {
						if ( ! $( e.target ).closest( self.selectors.element ).length ) {
							$input.trigger( 'blur' );
							$element.removeClass( 'opened' );
							$( document.body ).off( '.search-form' );
						}
					} );
				}
			} );

			$clear.on( 'click', function() {
				$input.val( '' );
				$input.trigger( 'focus' );
			} );

			$input.on('keyup focus', helpers.throttle( function() {
				$.ajax({
					type: "post",
					dataType: "json",
					url: themeVars.ajax_url,
					data: {
						action: 'bd_search_results',
						search: $input.val(),
					},
					success: function(response){
						$results.html(response.data.html);
					}
				});
			}, 200 ));

			$(document).on('keydown', function(event) {
				if (event.key === 'Escape') {
					$element.removeClass( 'opened' );
				}
			});
		} );
	}
}

export { searchForm };